/** Coding-exam languages. SQL is graded in-process. Python uses the local runner. React, Angular, and Selenium are reviewed, not executed. The rest run on Judge0. */
export const CODING_LANGUAGE_OPTIONS = [
  { id: 'python', label: 'Python' },
  { id: 'java', label: 'Java' },
  { id: 'javascript', label: 'JavaScript' },
  { id: 'cpp', label: 'C++' },
  { id: 'csharp', label: 'C#' },
  { id: 'vbnet', label: 'VB.NET' },
  { id: 'sql', label: 'SQL' },
  { id: 'react', label: 'React' },
  { id: 'angular', label: 'Angular' },
  { id: 'selenium', label: 'Selenium' },
];

export const REVIEW_LANGUAGES = new Set(['react', 'angular', 'selenium']);

export function isReviewLanguage(id) {
  return REVIEW_LANGUAGES.has(String(id || '').toLowerCase());
}

export const CLASSIC_CODING_LANGUAGES = CODING_LANGUAGE_OPTIONS.filter((l) => l.id !== 'sql');

export function codingLanguageLabel(id) {
  return CODING_LANGUAGE_OPTIONS.find((l) => l.id === id)?.label || id || 'Python';
}

export function codingLanguagesLabel(ids) {
  const list = Array.isArray(ids) && ids.length ? ids : ['python'];
  return list.map(codingLanguageLabel).join(', ');
}

/** At least one question per checked language, then leftover count is shared across them. */
export function questionCountsByLanguage(total, languages) {
  const langs = Array.isArray(languages) && languages.length ? languages : ['python'];
  const requested = Math.max(1, parseInt(total, 10) || langs.length);
  const target = Math.max(langs.length, requested);
  const counts = Object.fromEntries(langs.map((id) => [id, 1]));
  let extra = target - langs.length;
  let i = 0;
  while (extra > 0 && i < langs.length * 8) {
    const id = langs[i % langs.length];
    if (counts[id] < 5) {
      counts[id] += 1;
      extra -= 1;
    }
    i += 1;
  }
  return counts;
}

export const MONACO_LANGUAGE = {
  python: 'python',
  java: 'java',
  javascript: 'javascript',
  cpp: 'cpp',
  csharp: 'csharp',
  vbnet: 'vb',
  sql: 'sql',
  react: 'javascript',
  angular: 'typescript',
  // Selenium scripts are authored as Java WebDriver code and reviewed, not executed.
  selenium: 'java',
};
